// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface GitCreateBlobResponse {
  url: string;
  sha: string;
}
